<template>
  <div class="page-box">
    <div class="top">
      <el-form ref="form" :model="form" label-width="85px" inline style="display: flex; align-items: center">
        <el-form-item label="数据范围：">
          <el-select v-model="searchForm.orgCode" placeholder="请选择" size="small" @change="init">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in officeList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            class="data-picker"
            size="small"
            @change="timeChange"
            v-model="searchForm.time"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="false"
            :editable="false"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="text"
            :class="`${btnIndex == index ? 'btn-green' : 'bth-black'}`"
            v-for="(item, index) in ['本周', '本月', '本年']"
            :key="item"
            @click="timeTypeClick(item, index)"
            >{{ item }}</el-button
          >
        </el-form-item>
        <el-form-item label="支付方式：">
          <el-select v-model="searchForm.payType" placeholder="请选择" size="small" @change="init">
            <el-option label="全部" value=""></el-option>
            <el-option label="微信支付" value="1"></el-option>
            <el-option label="银联支付" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="content">
      <div class="content1">
        <div class="leftBox">
          <div class="title">销售额分析</div>
          <div class="left-chats" ref="oneLeftChats"></div>
        </div>
        <div class="rightBox">
          <div class="title">销售额占比分析</div>
          <div>
            <el-radio-group v-model="radioType" size="mini" @input="salesInfo"> 
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button label="0">报名费</el-radio-button>
              <el-radio-button label="1">秒杀</el-radio-button>
              <el-radio-button label="2">拼团</el-radio-button>
            </el-radio-group>
          </div>
          <div class="right-chats" ref="oneRightChats"></div>
        </div>
      </div>
      <div class="content2">
        <div class="title">顾客数分析</div>
        <div class="center-chats" ref="twoChats"></div>
      </div>
      <div class="content3">
        <div class="title">H5端登录分析</div>
        <div class="chats">
          <div class="leftBox" ref="thereChats"></div>
          <div class="rightBox">
            <div class="textBox">
              <div class="numBold">{{textForm.dailyLogin}}</div>
              <div class="textBold">日均登录人数</div>
              <div class="">本周期总登录人数: {{textForm.totalLogin}}人  &nbsp;&nbsp;&nbsp; 较上周期：<span class="green-text" :style="textForm.chainLogin < 0 ? 'color: red' : ''">{{textForm.chainLogin > 0 ? '+' : ''}}{{textForm.chainLogin}}%</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import oneLeftChats from "./mixins/oneLeftChats.mixin";
import oneRightChats from "./mixins/oneRightChats.mixin";
import twoChats from "./mixins/twoChats.mixin";
import thereChats from "./mixins/thereChats.mixin";
import moment from "moment";
export default {
  name: "DataAnalysisViews",
  mixins: [oneLeftChats, oneRightChats, twoChats, thereChats],
  components: {},
  data() {
    return {
      radioType: "",
      activeName: "",
      form: {},
      textForm: {},
      loadingAll: false,
      loading: false,
      loading2: false,
      loading3: false,
      btnIndex: 0,
      loadingIndex: 0,
      officeList: [],
      largeList: [],
      searchForm: {
        orgCode: "",
        time: [moment().startOf('week').format("YYYY-MM-DD 00:00:00"), moment().endOf('week').format("YYYY-MM-DD 23:59:59")],
        payType: "",
      },
      pickerOptions: {
        disabledDate(time) {
          const now = new Date(); // 获取当前时间
          const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate()); // 获取一年前的时间
          return time.getTime() < oneYearAgo.getTime() 
        }
      }
    };
  },
  mounted() {
    this.getOrgList();
    this.init();
  },
  watch: {
    loadingIndex(val,old) {
      if(val == 4) {
        setTimeout(() => {
          this.loadingAll.close()
        }, 500);
      }
    }
  },
  methods: {
    init() {
      this.loadingIndex = 0
      this.loadingAll = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
      this.customersDataList();
      this.salesInfo();
      this.rangeQueryDataList();
      this.h5LoginDataList();
    },
    timeTypeClick(item, index) {
      let week = [moment().startOf('week').format("YYYY-MM-DD 00:00:00"), moment().endOf('week').format("YYYY-MM-DD 23:59:59")]
      let month = [moment().startOf('month').format("YYYY-MM-DD 00:00:00"), moment().endOf('month').format("YYYY-MM-DD 23:59:59")]
      let year = [moment().startOf('year').format("YYYY-MM-DD 00:00:00"), moment().endOf('year').format("YYYY-MM-DD 23:59:59")]
      let time = index == 0 ? week : index === 1 ? month : index === 2 ? year : []
      this.$set(this.searchForm,'time',time)
      this.btnIndex = index;
      this.init()
    },
    getOrgList() {
      this.$api.home.getOrgList().then((res) => {
        this.officeList = res.data;
      });
    },
    rangeQueryDataList() {
      this.loading = true;
      let { time, orgCode,payType } = this.searchForm;
      let data = {
        filterData: {
          orgCode: orgCode,
          startTime: time ? time[0] : "",
          endTime: time ? time[1] : "",
          type: this.btnIndex + 1,
          findType: 1,
          payWay:payType
        }, 
        pageNum: 1,
        pageSize: 99999,
      };
      if(this.btnIndex < 0) {
        delete data.filterData.type
      }else {
        delete data.filterData.startTime
        delete data.filterData.endTime
      }
      this.$api.home
        .rangeQueryDataList(data)
        .then((res) => {
          this.render_one_left(res.data.list);
        })
        .finally((_) => {
          this.loading = false;
          this.loadingIndex += 1;
        });
    },
    customersDataList() {
      this.loading2 = true;
      let { time, orgCode, payType } = this.searchForm;
      let data = {
        orgCode: orgCode,
        startTime: time ? time[0] : "",
        endTime: time ? time[1] : "",
        type: this.btnIndex + 1,
        findType: 1,
        payWay:payType,
      };
      this.$api.home
        .customersDataList(data)
        .then((res) => {
          this.render_two(res.data);
        })
        .finally((_) => {
          this.loading2 = false;
          this.loadingIndex += 1;
        });
    },
    h5LoginDataList() {
      this.loading3 = true;
      let { time, orgCode ,payType} = this.searchForm;
      let data = {
        orgCode: orgCode,
        startTime: time ? time[0] : "",
        endTime: time ? time[1] : "",
        type: this.btnIndex + 1,
        findType: 1,
        payWay: payType
      };
      this.$api.home
        .h5LoginDataList(data)
        .then((res) => {
          this.render_there_left(res.data);
          this.textForm = res.data;
        })
        .finally((_) => {
          this.loading3 = false;
          this.loadingIndex += 1;
        });
    },
    salesInfo() {
      let { time, orgCode,payType } = this.searchForm;
      let data = {
        orgCode: orgCode,
        startTime: time ? time[0] : "",
        endTime: time ? time[1] : "",
        type: this.btnIndex + 1,
        payWay: payType,
      };
      this.$api.home
        .salesInfo(data)
        .then((res) => {
          this.render_one_right(res.data,this.radioType);
        })
        .finally((_) => {
          this.loadingIndex += 1;
        });
    },
    timeChange() {
      this.btnIndex = -1
      this.init()
    }
  },
};
</script>

<style lang="stylus" scoped>
.page-box {
  height: calc(100% - 30px);
  border-radius: 5px;
  // overflow: auto;
  margin: 5px;
  padding: 10px;
  background: #FFF;

  .title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .top {
    .bth-black {
      color: #606266;
    }

    .btn-green {
      color: #0BB78E;
    }
  }

  .content {
    height: calc(100% - 50px);
    overflow: auto;
  }

  .content1 {
    display: flex;
    height: 350px;
    margin-bottom: 20px;

    .leftBox {
      flex: 7;

      .left-chats {
        width: 100%;
        height: calc(100% - 20px);
      }
    }

    .rightBox {
      flex: 3;

      .right-chats {
        width: 100%;
        height: calc(100% - 48px);
      }
    }
  }

  .content2 {
    height: 350px;
    margin-bottom: 20px;

    .center-chats {
      width: 100%;
      height: 100%;
    }
  }

  .content3 {
    height: 350px;
    margin-bottom: 20px;

    .chats {
      width: 100%
      height: calc(100% - 20px)
      display: flex;

      .leftBox {
        flex: 7;
      }

      .rightBox {
        flex: 3;
        margin: 30px 20px 10px 20px
        padding: 20px
          .textBox {
            padding-top: 30px
            width: 100%
            height: calc(100% - 30px)
            text-align: center
            background: #F2F2F2
            line-height: 64px
              .numBold {
                font-size: 30px
                font-weight: bold
              }
              .textBold{
                font-size: 16px
                font-weight: bold
              }
              .green-text{
                color: #0BB78E
              }
          }
      }
    }
  }
}

>>> .el-form-item {
  margin-bottom: 10px;
}

>>> .el-input--mini .el-input__inner {
  width: 150px;
}

>>> .el-date-editor.el-input__inner {
  width: 260px;
}
</style>
